module.exports = __webpack_public_path__ + "img/clima.b463db01.jpg";